import React, { Component, Fragment } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, FormControl, InputLabel, MenuItem, Pagination, Select, TextField, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { isNull, setHour } from '../../utility';

export default class formFiltersBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // parametri per filtri ricerca
            deviceId: this.props.vpn.idVpnPassForDetail === '' ? '' : this.props.vpn.idVpnPassForDetail,
            description: '',
            deviceModel: '',
            deviceVersion: '',
            devicePlatform: '',
            typeOrder: '',
            fieldOrder: '',
            user: '',
            key: '',
            createdStartAt: null,
            createdEndAt: null,
        };

        this.onChange = this.onChange.bind(this);
        this.setDateCreatedStartAt = this.setDateCreatedStartAt.bind(this);
        this.setDateCreatedEndAt = this.setDateCreatedEndAt.bind(this);
    }

    /**
     * Cambia il valore di quello stato.
     * 
     * @param {*} event 
     */
    onChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
        if (event.target.name === 'typeOrder') {
            setTimeout(() => {
                this.sendParamsForSearch();
            }, 200);
        }
    }

    // change per le date
    setDateCreatedStartAt = (newDate) => { this.setState({ createdStartAt: newDate }); }
    setDateCreatedEndAt = (newDate) => { this.setState({ createdEndAt: newDate }); }

    // Resetta tutti i filtri
    resetFilter = () => {
        this.setState({
            deviceId: '',
            description: '',
            deviceModel: '',
            deviceVersion: '',
            devicePlatform: '',
            createdStartAt: null,
            createdEndAt: null,
            typeOrder: '',
            fieldOrder: '',
            user: '',
            key: ''
        });

        setTimeout(() => {
            this.sendParamsForSearch('vuoto');
        }, 300);
    }

    /**
     * Se viene premuto il tasto enter (Invio) avvia una ricerca
     */
    clickEnter = (event) => {
        if (event.keyCode === 13) {
            this.sendParamsForSearch();
        }
    }

    /**
     * Invia i parametri filtro per la ricerca.
     * Se il parametro vuoto è presente, invia stringhe vuote per la ricerca.
     * 
     * @param {*} label se è vuoto, manda parametri vuoti
     */
    sendParamsForSearch = (label) => {
        if (label === 'vuoto') {
            this.props.setParamsForSearch({
                deviceId: '',
                description: '',
                deviceModel: '',
                deviceVersion: '',
                devicePlatform: '',
                createdStartAt: '',
                createdEndAt: '',
                typeOrder: '',
                fieldOrder: '',
                user: '',
                key: ''
            });
        } else {
            this.props.setParamsForSearch({
                deviceId: this.state.deviceId,
                description: this.state.description,
                deviceModel: this.state.deviceModel,
                deviceVersion: this.state.deviceVersion,
                devicePlatform: this.state.devicePlatform,
                createdStartAt: this.state.createdStartAt === null ? '' : setHour(this.state.createdStartAt),
                createdEndAt: this.state.createdEndAt === null ? '' : setHour(this.state.createdEndAt),
                typeOrder: this.state.typeOrder,
                fieldOrder: this.state.fieldOrder,
                user: this.state.user,
                sortField: this.state.fieldOrder,
                sortType: this.state.typeOrder
            });
        }
    }

    render() {
        const { numberVpnBox, totalPages, setChange, currentNumberPage } = this.props;
        return (
            <Fragment>
                <div className="row itemForSearch">
                    <div className="col-12">
                        <TextField
                            name="deviceId"
                            variant='standard'
                            value={this.state.deviceId}
                            onChange={this.onChange}
                            onKeyDown={this.clickEnter}
                            label="Seriale"
                        />
                    </div>
                </div>

                <div className="row itemForSearch">
                    <div className="col-12">
                        <TextField
                            name="user"
                            variant='standard'
                            value={this.state.user}
                            onChange={this.onChange}
                            onKeyDown={this.clickEnter}
                            label="Utente"
                        />
                    </div>
                </div>

                <div className="row itemForSearch">
                    <div className="col-12 text-center">
                        <button
                            className={numberVpnBox === '10' ? "btnAround selected" : "btnAround"}
                            onClick={() => setChange({ target: { name: 'numberVpnBox' } }, '10')}
                        > 10 </button>
                        <button
                            className={numberVpnBox === '25' ? "btnAround selected" : "btnAround"}
                            onClick={() => setChange({ target: { name: 'numberVpnBox' } }, '25')}
                        > 25 </button>
                        <button
                            className={numberVpnBox === '50' ? "btnAround selected" : "btnAround"}
                            onClick={() => setChange({ target: { name: 'numberVpnBox' } }, '50')}
                        > 50 </button>
                    </div>
                </div>

                <div className="row itemForSearch">
                    <div className="col-12 text-center">
                        <Pagination
                            boundaryCount={2}
                            count={parseInt(totalPages) || 0}
                            page={parseInt(currentNumberPage)}
                            onChange={setChange}
                            color="primary"
                            showFirstButton
                            showLastButton
                            size="small"
                        />
                    </div>
                </div>

                <div className="row itemForSearch">
                    <div className="col-12 text-center">
                        <button className="btn btn-primary" style={{ 'margin': '10px' }} onClick={this.sendParamsForSearch}>
                            Cerca
                        </button>
                        <button className="btn btn-secondary" style={{ 'margin': '10px' }} onClick={this.resetFilter}>
                            Reset
                        </button>
                    </div>
                </div>

                <Accordion className="myAccordion">
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <Typography>Altri filtri</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography component="div">
                            <div className="row">
                                <div className="col-12 itemForSearch">
                                    <FormControl className='customSelect'>
                                        <InputLabel>Come vuoi ordinare?</InputLabel>
                                        <Select
                                            labelId="fieldOrderLabel"
                                            name="fieldOrder"
                                            variant='standard'
                                            value={this.state.fieldOrder}
                                            onChange={this.onChange}
                                        >
                                            <MenuItem value={'DeviceId'}>Vpn Box Serial</MenuItem>
                                            <MenuItem value={'DeviceModel'}>Device Model</MenuItem>
                                            <MenuItem value={'CreatedAt'}>Data Creazione</MenuItem>
                                            <MenuItem value={'DeviceVersion'}>Device Version</MenuItem>
                                            <MenuItem value={'DevicePlatform'}>Device Platform</MenuItem>
                                            <MenuItem value={'User'}>User</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-12 itemForSearch">
                                    <FormControl disabled={this.state.fieldOrder === ''} className='customSelect'>
                                        <InputLabel>Tipo di Ordinamento</InputLabel>
                                        <Select
                                            labelId="typeOrderLabel"
                                            name="typeOrder"
                                            variant='standard'
                                            value={this.state.typeOrder}
                                            onChange={this.onChange}
                                        >
                                            <MenuItem value={'asc'}>Crescente [A-Z]</MenuItem>
                                            <MenuItem value={'desc'}>Decrescente [Z-A]</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>

                            <div className="row">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <div className="col-12 itemForSearch">
                                        <DatePicker
                                            variant="inline"
                                            format="DD/MM/YYYY"
                                            id="createdStartAt"
                                            label="Creata dal"
                                            value={this.state.createdStartAt}
                                            onChange={(newValue) => this.setDateCreatedStartAt(isNull(newValue) ? null : dayjs(newValue.$d))}
                                        />
                                    </div>

                                    <div className="col-12 itemForSearch">
                                        <DatePicker
                                            variant="inline"
                                            id="createdEndAt"
                                            label="Fino a"
                                            value={this.state.createdEndAt}
                                            onChange={(newValue) => this.setDateCreatedEndAt(isNull(newValue) ? null : dayjs(newValue.$d))}
                                            format="DD/MM/YYYY"
                                        />
                                    </div>
                                </LocalizationProvider>
                            </div>

                            <div className="row">
                                <div className="col-12 itemForSearch">
                                    <TextField
                                        name="description"
                                        variant='standard'
                                        value={this.state.description}
                                        onChange={this.onChange}
                                        onKeyDown={this.clickEnter}
                                        label="Descrizione"
                                    />
                                </div>

                                <div className="col-12 itemForSearch">
                                    <TextField
                                        name="deviceModel"
                                        variant='standard'
                                        value={this.state.deviceModel}
                                        onChange={this.onChange}
                                        onKeyDown={this.clickEnter}
                                        label="Device Model"
                                    />
                                </div>
                            </div>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Fragment>
        )
    }
}